import getWithToken from './base/get-with-token'

// const getSixCustomerTheMostAlert = getWithToken(`/alerts/six-customer-the-most`)
const getSixCustomerTheMostAlert = (type) => getWithToken(`/alerts/six-customer-the-most?type=${type}`)()

export default getSixCustomerTheMostAlert
